let configFile = "";

if (!process.env.REACT_APP_CONFIG) {
  configFile = "easygestor/local.json";
} else {
  configFile = process.env.REACT_APP_CONFIG;
}

export function getConfig() {
  return require(`../../config/envs/${configFile}`);
}



// WEBPACK FOOTER //
// ./src/utils/config.js